import { lazy } from "react";
import parseLanguages from "base-shell/lib/utils/locale";

import LayoutContainer from "containers/LayoutContainer/LayoutContainer";
import locales from "./locales";
import routes from "./routes";
import themes from "./themes";
import Loading from "../components/Loading/Loading";
import ShopProvider from "../providers/Shop";
import AuthProvider from "../providers/Auth";
import ActivityProvider from "../providers/Activity";

import { baseRoute, stage } from "./const";

const config = {
  containers: {
    LayoutContainer: ({ children, ...props }) => (
      <LayoutContainer {...props}>
        <AuthProvider>
          <ShopProvider
            mock={stage === "local" ? require("./mock").shop : undefined}
          >
            <ActivityProvider>{children}</ActivityProvider>
          </ShopProvider>
        </AuthProvider>
      </LayoutContainer>
    ),
  },
  components: {
    Loading,
  },
  pwa: {
    useiOSPWAPrompt: true,
    iOSPWAPromptProps: {},
  },
  routes: routes(baseRoute),
  locale: {
    locales,
    defaultLocale: parseLanguages(["zh-tw"], "zh-tw"),
    onError: (e) => {
      // Here we warn the user about translation error
      // console.warn(e)
      return;
    },
  },
  appbar: {
    width: 240,
  },
  menu: {
    offlineIndicatorHeight: 12,
    initialAuthMenuOpen: false,
    initialMiniMode: false,
    initialMenuOpen: true,
    initialMobileMenuOpen: false,
    initialMiniSwitchVisibility: true,
    useWindowWatcher: false,
  },
  theme: {
    themes,
    defaultThemeID: "default",
    defaultIsDarkMode: false,
    defaultIsRTL: false, //change this to true for default Right to Left Language support
  },
  pages: {
    PageNotFound: lazy(() => import("../pages/PageNotFound")),
    LandingPage: lazy(() => import("../pages/LandingPage")),
  },
  notistack: {},
};

export default config;
